import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UpcomingeventsListComponent } from './upcomingevents-list/upcomingevents-list.component';
import { UpcomingeventsCreateComponent } from './upcomingevents-create/upcomingevents-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: UpcomingeventsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: UpcomingeventsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'upcomingevents-create/:id',
        component: UpcomingeventsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UpcomingeventsRoutingModule { }
